import gsap from 'gsap'

class Circles2DMain {
  constructor() {
    this.bind()
    this.tlTime = 0
    this.animeTimeline = new gsap.timeline({
      defaultEase: 'linear',
      paused:true
    })

    this.params = {
      circleSet0: {
        count: 5,
        radiuses: [],
        positions: [],
        posIncOffset: 200,
        posOffset: 200,
        finalRadius: 600,

        opacities: []
      },
      circleSet1: {
        count: 10,
        scales: [],
        opacities: []
      },
      circleSet2: {
        count: 5,
        radiuses: [],
        positions: [],
        opacities: []
      },
    }

  }

  init(canvas) {
    this.ctx = canvas.getContext('2d')
    this.ctx.strokeStyle = "#325FFF"


    let dpi = window.devicePixelRatio
    this._w = window.innerWidth * dpi
    this._h = window.innerHeight * dpi

    this.ctx.canvas.width = this._w
    this.ctx.canvas.height = this._h

    for (let i = 0; i < this.params.circleSet0.count; i++) {
      const targetrad = this.params.circleSet0.finalRadius + i * this.params.circleSet0.posIncOffset
      const targetpos = i * this.params.circleSet0.posIncOffset + this.params.circleSet0.posOffset
      this.params.circleSet0.radiuses[i] = { value: 100 + (i - 1) * 50 }
      this.params.circleSet0.opacities[i] = { value: 0 }
      this.params.circleSet0.positions[i] = { value: 0 }
      const dura = .3
      const delay = i * .1
      this.animeTimeline.to(this.params.circleSet0.radiuses[i], {
        ease: 'linear',
        value: targetrad,
        delay: delay
      }, 0)
      this.animeTimeline.to(this.params.circleSet0.opacities[i], {
        ease: 'linear',
        value: 1,
        delay: delay
      }, 0)
      this.animeTimeline.to(this.params.circleSet0.radiuses[i], {
        ease: 'linear',
        value: this.params.circleSet0.finalRadius,
        delay: delay
      }, 1)
      if (i != 0)
        this.animeTimeline.to(this.params.circleSet0.opacities[i], {
          ease: 'linear',
          value: 0,
          delay: delay
        }, 1)
      this.animeTimeline.to(this.params.circleSet0.opacities[i], {
        ease: 'linear',
        value: 1,
        delay: delay
      }, 4)
      this.animeTimeline.to(this.params.circleSet0.radiuses[i], {
        ease: 'linear',
        value: targetrad - this.params.circleSet0.posOffset,
        delay: delay
      }, 4)
      this.animeTimeline.to(this.params.circleSet0.positions[i], {
        ease: 'linear',
        value: targetpos - ((this.params.circleSet0.count - 1) * this.params.circleSet0.posIncOffset + this.params.circleSet0.posOffset),
        delay: delay
      }, 4)
    }

    for (let i = 0; i < this.params.circleSet1.count; i++) {
      this.params.circleSet1.scales[i] = { value: 1 }
      this.params.circleSet1.opacities[i] = { value: 0 }
      const delay = i * .1
      this.animeTimeline.to(this.params.circleSet1.scales[i], {
        ease: 'linear',
        value: (i + 1) / this.params.circleSet1.count,
        delay: delay
      }, 2)
      this.animeTimeline.to(this.params.circleSet1.opacities[i], {
        ease: 'linear',
        value: 1,
        delay: delay
      }, 2)
      this.animeTimeline.to(this.params.circleSet1.scales[i], {
        ease: 'linear',
        value: 1,
        delay: delay
      }, 3)
      this.animeTimeline.to(this.params.circleSet1.opacities[i], {
        ease: 'linear',
        value: 0,
        delay: delay
      }, 3)
    }

    for (let i = 0; i < this.params.circleSet2.count; i++) {
      const targetpos = i * -this.params.circleSet0.posIncOffset - this.params.circleSet0.posOffset
      const orPos = i * this.params.circleSet0.posIncOffset + this.params.circleSet0.posOffset - ((this.params.circleSet0.count - 1) * this.params.circleSet0.posIncOffset + this.params.circleSet0.posOffset)
      this.params.circleSet2.radiuses[i] = { value: this.params.circleSet0.finalRadius + i * this.params.circleSet0.posIncOffset - this.params.circleSet0.posOffset }
      this.params.circleSet2.opacities[i] = { value: 0 }
      this.params.circleSet2.positions[i] = { value: orPos }
      const delay = i * .1

      this.animeTimeline.to(this.params.circleSet2.opacities[i], {
        ease: 'linear',
        value: 1,
        delay: delay
      }, 5)

      this.animeTimeline.to(this.params.circleSet2.positions[i], {
        ease: 'linear',
        value: targetpos - ((this.params.circleSet2.count - 1) * -this.params.circleSet0.posIncOffset - this.params.circleSet0.posOffset),
        delay: delay
      }, 5)
    }
    window.addEventListener('resize', this.resizeCanvas)
  }


  drawCircleSet0() {
    let i = 0
    while (i < this.params.circleSet0.count) {
      this.ctx.translate(this._w / 2, this._h / 2)
      this.ctx.beginPath()
      this.ctx.arc(this.params.circleSet0.positions[i].value, 0, this.params.circleSet0.radiuses[i].value, 0, Math.PI * 2)

      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.ctx.closePath()
      this.ctx.strokeStyle = `rgba(50,95,255,${this.params.circleSet0.opacities[i].value})`
      this.ctx.stroke()
      i++
    }
  }


  drawCircleSet1() {
    let i = 0
    while (i < this.params.circleSet1.count) {
      this.ctx.translate(this._w / 2, this._h / 2)

      this.ctx.scale(1, this.params.circleSet1.scales[i].value)
      this.ctx.beginPath()

      this.ctx.arc(0, 0, this.params.circleSet0.finalRadius, 0, Math.PI * 2)
      this.ctx.setTransform(1, 0, 0, 1, 0, 0)

      this.ctx.closePath()
      this.ctx.strokeStyle = `rgba(50,95,255,${this.params.circleSet1.opacities[i].value})`
      this.ctx.stroke()

      i++
    }
  }

  drawCircleSet2() {
    let i = 0
    while (i < this.params.circleSet2.count) {
      this.ctx.translate(this._w / 2, this._h / 2)
      this.ctx.beginPath()
      this.ctx.arc(this.params.circleSet2.positions[i].value, 0, this.params.circleSet2.radiuses[i].value, 0, Math.PI * 2)

      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.ctx.closePath()
      this.ctx.strokeStyle = `rgba(50,95,255,${this.params.circleSet2.opacities[i].value})`
      this.ctx.stroke()
      i++
    }
  }

  update() {
    // console.log(this.ctx);
    this.ctx.clearRect(0, 0, this._w, this._h)
    this.drawCircleSet0()
    this.drawCircleSet1()
    this.drawCircleSet2()

    this.animeTimeline.totalTime(this.tlTime)
  }

  resizeCanvas() {
    let dpi = window.devicePixelRatio
    this._w = window.innerWidth * dpi
    this._h = window.innerHeight * dpi

    this.ctx.canvas.width = this._w
    this.ctx.canvas.height = this._h


  }

  bind() {
    this.update = this.update.bind(this)
    this.resizeCanvas = this.resizeCanvas.bind(this)
  }

}

const _instance = new Circles2DMain()
export default _instance
